import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// JSON 파일 import
import translationKo from './locales/ko/translation.json';
import translationEn from './locales/en/translation.json';

const resources = {
  ko: { translation: translationKo },
  en: { translation: translationEn },
};

i18n
  .use(LanguageDetector) // 브라우저 언어 감지
  .use(initReactI18next) // React와 연결
  .init({
    resources,
    fallbackLng: 'en', // 번역이 없을 경우 한국어 사용
    interpolation: {
      escapeValue: false, // React에서는 불필요한 XSS 방지
    },
    detection: {
      order: ['localStorage', 'navigator'], // 로컬스토리지 → 브라우저 언어 우선순위
      caches: ['localStorage'], // 선택한 언어 기억
    },
  });

export default i18n;
